/* LightSeek lighting calculators — vanilla port of components/calculators/LightingCalculators.tsx */
(function () {
  'use strict';

  var fmt = function (n, digits) {
    return Number.isFinite(n) && n >= 0
      ? n.toLocaleString('en-US', { maximumFractionDigits: digits == null ? 2 : digits })
      : '—';
  };

  var fmtLux = function (n) {
    return Number.isFinite(n) && n >= 0
      ? n.toLocaleString('en-US', { maximumFractionDigits: n < 10 ? 1 : 0 })
      : '—';
  };

  var toNum = function (v) {
    var n = Number(v);
    return Number.isFinite(n) ? n : NaN;
  };

  function input(root, name) {
    return root.querySelector('[data-calc-input="' + name + '"]');
  }
  function out(root, name) {
    return root.querySelector('[data-calc-out="' + name + '"]');
  }
  function setText(root, name, text) {
    var el = out(root, name);
    if (el) el.textContent = text;
  }

  /* ---------- 1. Beam coverage & illuminance ---------- */
  var beam = document.querySelector('[data-ls-calc="beam"]');
  if (beam) {
    var updateBeam = function () {
      var ang = toNum(input(beam, 'angle').value);
      var h = toNum(input(beam, 'height').value);
      var lm = toNum(input(beam, 'lumens').value);
      var valid = ang > 0 && ang < 180 && h > 0 && lm > 0;

      var dia = valid ? 2 * h * Math.tan((ang * Math.PI) / 360) : NaN;
      var area = dia > 0 ? Math.PI * Math.pow(dia / 2, 2) : NaN;
      var lux = area > 0 && area < Infinity ? lm / area : NaN;

      setText(beam, 'beam-dia', fmt(dia));
      setText(beam, 'beam-area', fmt(area));
      setText(beam, 'beam-lux', fmtLux(lux));
    };
    Array.prototype.forEach.call(beam.querySelectorAll('[data-calc-input]'), function (el) {
      el.addEventListener('input', updateBeam);
      el.addEventListener('change', updateBeam);
    });
    updateBeam();
  }

  /* ---------- 2. Fixture count ---------- */
  var fixture = document.querySelector('[data-ls-calc="fixture"]');
  if (fixture) {
    var updateFixture = function () {
      var E = toNum(input(fixture, 'lux').value);
      var A = toNum(input(fixture, 'area').value);
      var F = toNum(input(fixture, 'lm').value);
      var UF = toNum(input(fixture, 'uf').value);
      var LLF = toNum(input(fixture, 'llf').value);
      var valid = E > 0 && A > 0 && F > 0 && UF > 0 && UF <= 1 && LLF > 0 && LLF <= 1;

      var perFixture = valid ? F * UF * LLF : NaN;
      var count = valid ? Math.ceil((E * A) / perFixture) : NaN;
      var achieved = valid ? (perFixture * count) / A : NaN;

      setText(fixture, 'fc-count', Number.isFinite(count) ? fmt(count, 0) : '—');
      setText(
        fixture,
        'fc-achieved',
        valid ? fmtLux(achieved) + ' lx (≈ target ' + fmtLux(E) + ' lx)' : '—'
      );
      setText(fixture, 'fc-per', (valid ? fmt(perFixture, 0) : '—') + ' lm');
    };
    Array.prototype.forEach.call(fixture.querySelectorAll('[data-calc-input]'), function (el) {
      el.addEventListener('input', updateFixture);
      el.addEventListener('change', updateFixture);
    });
    updateFixture();
  }

  /* ---------- 3. Container loading ---------- */
  var CONTAINERS = {
    '20GP': { l: 5898, w: 2352, h: 2393, payloadKg: 28200, volM3: 33.2 },
    '40HQ': { l: 12032, w: 2352, h: 2698, payloadKg: 26500, volM3: 76.4 }
  };
  var ORIENTATIONS = [
    [0, 1, 2], [0, 2, 1], [1, 0, 2],
    [1, 2, 0], [2, 0, 1], [2, 1, 0]
  ];

  var cont = document.querySelector('[data-ls-calc="container"]');
  if (cont) {
    var updateContainer = function () {
      var c = CONTAINERS[input(cont, 'container').value] || CONTAINERS['20GP'];
      var mmL = toNum(input(cont, 'len').value) * 10;
      var mmW = toNum(input(cont, 'wid').value) * 10;
      var mmH = toNum(input(cont, 'hgt').value) * 10;
      var wt = toNum(input(cont, 'wt').value);
      var valid = mmL > 0 && mmW > 0 && mmH > 0 && wt > 0;

      var best = null;
      if (valid) {
        var dims = [mmL, mmW, mmH];
        for (var i = 0; i < ORIENTATIONS.length; i++) {
          var p = ORIENTATIONS[i];
          var cx = Math.floor(c.l / dims[p[0]]);
          var cy = Math.floor(c.w / dims[p[1]]);
          var cz = Math.floor(c.h / dims[p[2]]);
          var count = cx * cy * cz;
          if (!best || count > best.count) {
            best = { count: count, alloc: [cx, cy, cz] };
          }
        }
      }

      var byWeight = valid ? Math.floor(c.payloadKg / wt) : NaN;
      var total = best ? Math.min(best.count, byWeight) : NaN;
      var cartonM3 = valid ? (mmL * mmW * mmH) / 1e9 : NaN;
      var volUtil = total > 0 && cartonM3 > 0 ? (total * cartonM3) / c.volM3 : NaN;
      var wtUtil = total > 0 ? (total * wt) / c.payloadKg : NaN;
      var weightLimited =
        Number.isFinite(byWeight) &&
        Number.isFinite(total) &&
        byWeight <= total + 1e-9 &&
        byWeight < (best ? best.count : Infinity);

      var orientationLabel =
        best && valid
          ? fmt(mmL) + 'mm × ' + fmt(mmW) + 'mm × ' + fmt(mmH) + 'mm → ' +
            best.alloc[0] + ' × ' + best.alloc[1] + ' × ' + best.alloc[2] +
            ' (length × width × height)'
          : '';

      setText(cont, 'cont-total', fmt(total, 0));
      setText(cont, 'cont-orient', orientationLabel || '—');
      setText(cont, 'cont-vol', valid ? fmt(volUtil, 1) : '—');
      setText(cont, 'cont-wtutil', valid ? fmt(wtUtil, 1) : '—');

      var note = out(cont, 'cont-note');
      if (note) note.hidden = !(valid && weightLimited);
    };
    Array.prototype.forEach.call(cont.querySelectorAll('[data-calc-input]'), function (el) {
      el.addEventListener('input', updateContainer);
      el.addEventListener('change', updateContainer);
    });
    updateContainer();
  }
})();
